module.exports = __webpack_public_path__ + "ccc75b4.webp";